import * as Yup from 'yup';
import { isValidVin } from 'core/helpers/vin-validator';

export const vinSchema = Yup.object().shape({
  VIN: Yup.string()
    .ensure()
    .test('is-valid-vin', 'Please enter a valid car VIN', (val) => isValidVin(val))
    .required()
});

export const homeSchema = Yup.object().shape({
  home: Yup.object()
    .shape({
      basementSqFt: Yup.string().requiredString('Square footage of basement is required'),
      basementType: Yup.string().requiredString('Basement type is required'),
      constructionType: Yup.string().requiredString('Construction type is required'),
      exteriorWallType: Yup.string().requiredString('Exterior wall type is required'),
      garageCarCapacity: Yup.string().requiredString('Garage car capacity is required'),
      garageType: Yup.string().requiredString('Garage type is required'),
      homeQuality: Yup.string().requiredString('Home quality is required'),
      numFamiliesInDwelling: Yup.string().requiredString('Number of families in the dwelling is required'),
      numFireplaces: Yup.string().requiredString('Number of fireplaces is required'),
      numFullBathrooms: Yup.string().requiredString('Number of full bathrooms is required'),
      numHalfBathrooms: Yup.string().requiredString('Number of half bathrooms is required'),
      numStories: Yup.string().requiredString('Number of stories is required'),
      numWoodBurningStoves: Yup.string().requiredString('Number of wood burning stoves is required'),
      purchaseDate: Yup.string().validHomePurchaseDate('home.purchaseDate'),
      roofShape: Yup.string().requiredString('Roof shape is required'),
      roofType: Yup.string().requiredString('Roof type is required'),
      roofYear: Yup.string().requiredString('Roof year is required'),
      sqFt: Yup.string().requiredString('Square footage is required'),
      typeOfHome: Yup.string().requiredString('Type of home is required'),
      yearBuilt: Yup.string().requiredString('Build year is required')
    })
    .required()
});

export const priorCoverageSchema = Yup.object().shape({
  global: Yup.object()
    .shape({
      currentAutoCarrier: Yup.string().required('Current carrier is required'),
      continuousAutoCoverageStartDate: Yup.string().required('Auto coverage start date is required'),
      mostRecentAutoInsuranceCoverageEndDate: Yup.string().required('Coverage expiration date is required'),
      priorIndividualBILimit: Yup.number()
        .transform((value, originalValue) => (originalValue === '' ? undefined : value))
        .required('Prior bodily injury limit (individual) is required'),
      priorOccurrenceBILimit: Yup.number()
        .transform((value, originalValue) => (originalValue === '' ? undefined : value))
        .required('Prior bodily injury limit (occurrence) is required'),
      priorUmIndividualBodilyInjury: Yup.number()
        .transform((value, originalValue) => (originalValue === '' ? undefined : value))
        .required('Prior uninsured motorist BI (individual) is required'),
      priorUmOccurrenceBodilyInjury: Yup.number()
        .transform((value, originalValue) => (originalValue === '' ? undefined : value))
        .required('Prior uninsured motorist BI (occurrence) is required')
    })
    .required()
});
